import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { UpgradeModule } from '@angular/upgrade/static';
import { AngularSplitModule } from 'angular-split';
import { JwtHelperService, JWT_OPTIONS  } from '@auth0/angular-jwt';
// import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { angular1Providers } from './angular1-providers';
import { Store } from '@src/store';
import { DBConnectionComponentService, DialogManagerService, SessionService } from '@src/services';

import { AuthenticationModule } from './authentication/authentication.module';
import { AuthorizedModule } from './authorized/authorized.module';
import { SharedModule } from './shared/shared.module';

@NgModule({
    providers: [
        ...angular1Providers,
        Store,
        DBConnectionComponentService,
        DialogManagerService,
        SessionService,
        { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
        JwtHelperService
    ],
    imports: [
        BrowserModule,
        UpgradeModule,
        AngularSplitModule.forRoot(),
        // UIRouterUpgradeModule.forRoot(),

        AuthenticationModule,
        AuthorizedModule,
        SharedModule
    ]
})
export class AppModule {
    constructor(private upgrade: UpgradeModule) {
    }

    public ngDoBootstrap() {
        this.upgrade.bootstrap(document.documentElement, ['app'], { strictDi: true });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/app.module.ts